import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false;

const el = document.getElementById('app');
Vue.prototype.$agreementUrl = el.dataset.agreementUrl;

new Vue({
  router,
  render: h => h(App)
}).$mount(el);
